module.exports = __webpack_public_path__ + "img/3.7e5bd210.png";